import React, { useState } from "react";
import PropTypes from "prop-types";
import { toExcelNumberFormatWithDecimals } from "../../../utils/format";
import "./ActualOrderCell.css";
import { parseNonNegativeNumber } from "../../../utils/format";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import ToastI18nWrapper from "../../ToastI18nWrapper/ToastI18nWrapper";
import { selectedActualOrderCell } from "../../../actions/ordersTable";

// The implementation of this editable cell was taked from react table docs check:
// https://react-table-v7.tanstack.com/docs/examples/editable-data 

const ActualOrderCell = ({
  cell: { value: initialValue },
  row: { index },
  column: { id },
  updateTableData, // This is a custom function that we supplied to our table instance
  decimalsNumber, // This is supplied to our table instance the same way as updateTableData
  selectedActualOrderCell,
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState(initialValue);
  const [changed, setChanged] = useState(false);
  const temporalInput = document.getElementById(`actual-order-input+${index}`)


  // The typed text is validated on submit, so values like "1e3" or "-5" aren't mangled while typing
  const onChange = (e) => {
    if (!changed) {
      setChanged(true);
    }
    setValue(e.target.value);
  };

  const submitChange = (newValue, performRequest = true) => {
    const parsedValue = parseNonNegativeNumber(newValue);
    if (parsedValue === null) {
      toast.error(<ToastI18nWrapper translateKey={"ordersTable.invalidActualOrder"} />, {
        toastId: "invalidActualOrder",
      });
      setValue(toExcelNumberFormatWithDecimals(initialValue, undefined, decimalsNumber));
      return;
    }
    setValue(toExcelNumberFormatWithDecimals(parsedValue, undefined, decimalsNumber));
    updateTableData(index, id, parsedValue, performRequest);
  };

  React.useEffect(() => {
    setValue(toExcelNumberFormatWithDecimals(initialValue, undefined, decimalsNumber));
  }, [initialValue, decimalsNumber]);


  const keyPressedHandler = (event)=>{
    if(event.key === 'Enter'){
      temporalInput.focus();
      temporalInput.blur();
      selectedActualOrderCell(false)
    }
  }

  return (
    <div className="ui input actual-order">
      <input
        id={`actual-order-input+${index}`}
        className="actual-order"
        type="text"
        value={value}
        key={id}
        onChange={onChange}
        onBlur={() => {
          if (changed) {
            submitChange(value);
            setChanged(false);
          }
          selectedActualOrderCell(false)
        }}
        onKeyPress={(event) => {keyPressedHandler(event)}}
        onClick={() => {selectedActualOrderCell(true)}}
      />
    </div>
  );
};

ActualOrderCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  column: PropTypes.object,
  updateTableData: PropTypes.func,
  decimalsNumber: PropTypes.number,
  selectedActualOrderCell: PropTypes.func,
};

export default connect(null, { selectedActualOrderCell })(ActualOrderCell);
